export enum UserGroup {

    CommonAreaAccess = 'APP-BHPVillageOps-WAIO-CAA',
    CommonDoorSchedule = 'APP-BHPVillageOps-WAIO-EXT-CAS',
    BatteryMonitor = 'APP-BHPVillageOps-WAIO-DoorBattMon',
    ExternalBatteryMonitor = 'APP-BHPVillageOps-WAIO-EXT-DoorBattMon',
    Diagnostics = 'APP-BHPVillageOps-WAIO-Diagnostics',
    ESSSupervisor = 'APP-BHPVillageOps-WAIO-EXT-CAA-ESS',
    ExternalCommonAreaUsers = 'APP-BHPVillageOps-WAIO-EXT-CAA',
    ExternalGymUsers = 'APP-BHPVillageOps-WAIO-EXT-GYM',
    GymCompetency = 'APP-BHPVillageOps-WAIO-Gym',
    IotGatewayDashboard = 'APP-BHPVillageOps-WAIO-IoTAPMon',
    ExternalIotGatewayDashboard = 'APP-BHPVillageOps-WAIO-EXT-IoTAPMon',
    IotDeviceDashboard = 'APP-BHPVillageOps-WAIO-IoTDoorMon',
    ExternalIotDeviceDashboard = 'APP-BHPVillageOps-WAIO-EXT-IoTDoorMon',
    NPIHousing = 'APP-BHPVillageOps-WAIO-EXT-CAA-NPIHousing',
    NPIOps = 'APP-BHPVillageOps-WAIO-EXT-CAA-NPIOps',
    SpokeDashboard = 'APP-BHPVillageOps-WAIO-WAPMon',
    VillageWiFi = 'APP-BHPVillageOps-WAIO-WiFi',
    WaioSecurity = 'APP-BHPVillageOps-WAIO-Security',
    WaioReception = 'APP-BHPVillageOps-WAIO-Reception',
    WaioUsers = 'APP-BHPVillageOps-WAIO-Users',

};